// Add your custom JS here.


jQuery(document).ready(function($) {

    // Get the height of the "psc-internal-header" div
    var headerHeight = $(".psc-internal-header").height();

    // Add a scroll event listener
    $(window).scroll(function () {
        // Calculate the current scroll position
        var scrollPosition = $(window).scrollTop();

        // Check if the scroll position has reached the bottom of the header
        if (scrollPosition >= headerHeight) {
            // Add the "fixed" class to the "psc-jump-nav" div
            $(".psc-jump-nav").addClass("fixed");
            $(".about-wrapper").addClass("fixed");
        } else {
            // Remove the "fixed" class if the scroll position is above the header
            $(".psc-jump-nav").removeClass("fixed");
            $(".about-wrapper").removeClass("fixed");
        }
    });

     $(window).scroll(function(){

      var header = $("#main-nav").height();
      var hero = $(".psc-hero").height();
      var sticky = $(".psc-hero__register-btn").height();
      var total = hero - sticky;
      var secondTotal = hero + header;
        var sTop= $(this).scrollTop();
        if(sTop >= total){
          $('.psc-hero__register-btn').addClass('sticky-button');
          $('.psc-hero__fixed-wrapper__logo').addClass('sticky-header');
          $('.psc-hero__fixed-wrapper__logo').removeClass('d-none');
          $('.psc-hero__fixed-wrapper__logo').addClass('fade-header');

        } else if(sTop <= secondTotal){
          $('.psc-hero__register-btn').removeClass('sticky-button');
          $('.psc-hero__fixed-wrapper__logo').removeClass('sticky-header');
          $('.psc-hero__fixed-wrapper__logo').addClass('d-none');
          $('.psc-hero__fixed-wrapper__logo').removeClass('fade-header');
        }
    });
    $('.js-previous').slick({
        autoplaySpeed: 4000,
        slidesToScroll: 1,
        dots:false,
        autoplay: true,
        nextArrow: '.nextimage',
        prevArrow: '.previmage',
    });

   $('.auto-play-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplaySpeed: 1800,
    dots:false,
    autoplay: true,
    nextArrow: '.next',
    prevArrow: '.prev',
 
     responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
 });

 ScrollTrigger.batch(".member-teasers , .psc-news__teaser, .participant-wrapper", {
          start: "bottom bottom",
          onEnter: batch => gsap.to(
              batch, {
                autoAlpha: 1,
                stagger: 0.1,
                duration: 0.6
                 }
              ),
        });


jQuery( document ).ready(function() {

     if(document.querySelector(".psc-stories-teaser")) {
            var tl = gsap.timeline({
               scrollTrigger: {
                trigger: '.psc-stories-teaser__text',
                }
            })

             tl.from(".psc-stories-teaser__second",{
                        y: 230,    
                        opacity: 0, 
                        duration: 0.5,
                    }   
            )
            tl.from(".psc-stories-teaser__first",{
                        x: 230,    
                        opacity: 0, 
                        duration: 0.5,
                    }   
            )
            tl.from(".psc-stories-teaser__text",{
                        x: -100,    
                        opacity: 0, 
                        duration: 0.5,
                    }   
            )
        } 



if(document.querySelector(".psc-about-section")) {
        var tl = gsap.timeline({
           scrollTrigger: {
            trigger: '.psc-about-section',
            }
        })

         tl.from(".psc-about-section",{
                    y: 200,    
                    opacity: 0, 
                    duration: 0.6,
                }   
        )

    }

    if(document.querySelector(".psc-story__wrapper")) {
            var tl = gsap.timeline({
               scrollTrigger: {
                trigger: '.psc-story__wrapper',
                }
            })

             tl.from(".psc-story__wrapper .col-md-8",{
                        y: 100,    
                        opacity: 0, 
                        duration: 0.6,
                    }   
            )
            tl.from(".psc-story__wrapper .col-md-4",{
                        x: 130,    
                        opacity: 0, 
                        duration: 0.6,
                    }   
            )   
        } 


    if(document.querySelector(".psc-registration__content")) {
        var tl = gsap.timeline({
           scrollTrigger: {
            trigger: '.psc-registration__content',
            }
        })

         tl.from(".psc-registration__content",{
                    y: 100,    
                    opacity: 0, 
                    duration: 0.6,
                }   
        )

    }


    if(document.querySelector(".psc-internal-header")) {
        var tl = gsap.timeline({
           scrollTrigger: {
            trigger: '.psc-internal-header',
            }
        })

         tl.from(".psc-internal-header__text",{
                    x: -200,    
                    opacity: 0, 
                    duration: 0.6,
                }   
        )

        tl.from(".psc-internal-header__imagechallenge img",{
                    x: 200,    
                    opacity: 0, 
                    duration: 0.6,
                }   
        )
        tl.from(".psc-internal-header__image img",{
                    x: 200,    
                    opacity: 0, 
                    duration: 0.6,
                }   
        )

    } 


     if(document.querySelector(".psc-about")) {
        var tl = gsap.timeline({
           scrollTrigger: {
            trigger: '.psc-about',
            }
        })

         tl.from(".psc-about h2",{
                    y: 50,    
                    opacity: 0, 
                    duration: 0.6,
                }   
        )

        tl.from(".psc-about p",{
                    y: 50,    
                    opacity: 0, 
                    duration: 0.6,
                }   
        )

         tl.from(".psc-about__images__first",{
                    x: -100,    
                    opacity: 0, 
                    duration: 0.4,
                }   
        )

          tl.from(".psc-about__images__second",{
                    x: -100,    
                    opacity: 0, 
                    duration: 0.4,
                }   
        )

           tl.from(".psc-about__images__third",{
                    x: -100,    
                    opacity: 0, 
                    duration: 0.4,
                }   
        )

    } 


     if(document.querySelector(".psc-about__cta")) {
        var tl = gsap.timeline({
           scrollTrigger: {
            trigger: '.psc-about__cta a',
            }
        })

         tl.from(".psc-about__cta h3",{
                    y: -50,    
                    opacity: 0, 
                    duration: 0.6,
                }   
        )
    } 


     if(document.querySelector(".psc-previous-section")) {
        var tl = gsap.timeline({
           scrollTrigger: {
            trigger: '.h3-title',
            }
        })

         tl.from(".h3-title",{
                    y: -50,    
                    opacity: 0, 
                    duration: 0.5,
                }   
        )

        tl.from(".position-relative",{
                    y: -50,    
                    opacity: 0, 
                    duration: 0.5,
                }   
        )

         tl.from(".padding-right-void",{
                    y: -50,    
                    opacity: 0, 
                    duration: 0.5,
                }   
        )
    } 


    if(document.querySelector(".psc-news__filter-band")) {
        var tl = gsap.timeline({
           scrollTrigger: {
            trigger: '.h3-title',
            }
        })

         tl.from(".h3-title",{
                    y: -50,    
                    opacity: 0, 
                    duration: 0.5,
                }   
        )

        tl.from(".news-category-filter",{
                    y: 50,    
                    opacity: 0, 
                    duration: 0.5,
                }   
        )
    } 

       if(document.querySelector(".archive-intro")) {
        var tl = gsap.timeline({
           scrollTrigger: {
            trigger: '.h3-title',
            }
        })

         tl.from("h3",{
                    y: -50,    
                    opacity: 0, 
                    duration: 0.5,
                }   
        )

        tl.from(".archive-intro p , .archive-intro a",{
                    y: 50,    
                    opacity: 0, 
                    duration: 0.5,
                }   
        )
    }

    if(document.querySelector(".psc-latest")) {
        var tl = gsap.timeline({
           scrollTrigger: {
            trigger: '.psc-latest',
            }
        })

        tl.from(".psc-latest__grid__box",{
                    x: -200, 
                    opacity: 0, 
                    duration: 0.4,
                }   
        )

        tl.from(".psc-latest__grid__image-box",{
                    x: -200, 
                    opacity: 0, 
                    duration: 0.4,
                }   
        )

        tl.from(".psc-latest__grid__featured-stories",{
                    x: 50, 
                    opacity: 0, 
                    duration: 0.4,
                } 
            )

        tl.from(".psc-latest__current",{
                    x: 50, 
                    opacity: 0, 
                    duration: 0.4,
                } 
            )
        } 


     if(document.querySelector(".psc-stories__text")) {
        var tl = gsap.timeline({
           scrollTrigger: {
            trigger: '.psc-stories__text',
            }
        })

         tl.from(".clipped-img",{
                    x: -200, 
                    opacity: 0, 
                    duration: 0.3,
                }   
        )

        tl.from(".psc-stories__images__first",{
                    x: 50, 
                    opacity: 0, 
                    duration: 0.3,
                } 
            )

        tl.from(".psc-stories__images__second",{
                    x: 50, 
                    opacity: 0, 
                    duration: 0.3,
                } 
            )

        tl.from(".psc-stories__images__third",{
                    x: 50, 
                    opacity: 0, 
                    duration: 0.3,
                } 
            )


        tl.from(".psc-stories__text",{
                    y: 100, 
                    opacity: 0, 
                    duration: 0.3,
                } 
            )
        } 

        if(document.querySelector(".psc-challenge__text")) {
        var tl = gsap.timeline({
           scrollTrigger: {
            trigger: '.psc-challenge__text',
            }
        })

         tl.from(".psc-challenge",{
                    x: 200, 
                    opacity: 0, 
                    duration: 0.3,
                }   
        )

        tl.from(".psc-challenge__images__first",{
                    x: -200, 
                    opacity: 0, 
                    duration: 0.3,
                }   
        )

        tl.from(".psc-challenge__images__second",{
                    x: -200, 
                    opacity: 0, 
                    duration: 0.3,
                } 
            )

        tl.from(".psc-challenge__images__third",{
                    x: -200, 
                    opacity: 0, 
                    duration: 0.3,
                } 
            )

        tl.from(".psc-challenge__text",{
                    y: 100, 
                    opacity: 0, 
                    duration: 0.3,
                } 
            )
        } 


 if(document.querySelector(".psc-hero")) {
        var tl = gsap.timeline({
           trigger: '.psc-hero',
        })

        tl.from(".psc-hero__background-overlay, .psc-hero__video-container video",{
                    y: -200, 
                    opacity: 0, 
                    duration: .6
                }   
        )

        tl.from(".psc-hero__wrapper--box",{
                    x: -300, 
                    opacity: 0, 
                    duration: 0.3
                } 
            )

        tl.from(".psc-hero__register-btn",{
                    x: 200, 
                    opacity: 0, 
                    duration: 0.3
                } 
            )

        tl.from(".psc-hero__content__title",{
                    y: 100, 
                    opacity: 0, 
                    duration: 0.3
                } 
            )

        tl.from(".psc-hero__content__text",{
                    y: 100, 
                    opacity: 0, 
                    duration: 0.3
                } 
            )

        tl.from(".psc-hero__cta a",{
                    y: 100, 
                    opacity: 0, 
                    duration: 0.3
             } 
        )

        tl.from(".psc-hero__play-icon",{
                    y: 0, 
                    opacity: 0, 
                    duration: 0.3
                } 
             )
        } 
}); 